import type { ComponentProps } from "react";
import { styled } from "@repo/styled-system/jsx";
import { type TextVariantProps, text } from "@repo/styled-system/recipes";
import type { StyledComponent } from "@repo/styled-system/types";

type Props = TextVariantProps & { as?: React.ElementType };

export type TextProps = ComponentProps<typeof Text>;
export const Text = styled("p", text) as StyledComponent<"p", Props>;
